import { Injectable } from '@angular/core'
import { AuthenticationService } from '../../authentication/services/authentication.service'
import { createIdentifyData } from '../util/createIdentifyData'
import { _hsq } from '../util/_hsq'
import { HubspotIdentifyData } from '../types/hubspotIdentifyData'

@Injectable()
export class HubspotAnalyticsService {
    constructor(private authenticationService: AuthenticationService) {}

    bootstrap() {
        // automatically identify with hubspot when a user logs in
        this.authenticationService.currentUser.subscribe(user => {
            const identifyData: HubspotIdentifyData = {}

            if (user) {
                identifyData.id = user.id
                identifyData.email = user.email
            }

            _hsq.push(['identify', createIdentifyData(identifyData)])
        })

        this.authenticationService.signupEmail.subscribe(emailAddress => {
            _hsq.push(['identify', createIdentifyData({ email: emailAddress })])

            _hsq.push([
                'trackEvent',
                {
                    id: 'User signup',
                    value: emailAddress,
                },
            ])
        })
    }
}
